import product from '../../assets/Products/shapeCard.avif'
import hoverCrad from '../../assets/Products/hoverCard.avif'
import pattren from '../../assets/Products/pattren.png'
import CCAiView from '../../assets/Products/Graphite.avif'
import LMSView from '../../assets/Products/LMS.avif'
import CCAtsView from '../../assets/Products/atsProduct.avif'
import HRMSView from '../../assets/Products/hrmsProduct.avif'

import CCAts from '../../assets/CC ATS Logo 1.svg'
import CCAi from '../../assets/cc Ai.svg'
import san from '../../assets/SAN Technovation - Logo 1 3.avif'
import { FiArrowRight } from "react-icons/fi";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useNavigate } from 'react-router-dom'
// import { view } from 'framer-motion/client'

export default function ProductList() {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const navigate = useNavigate()

    const products = [
        {
            id: 'ccai',
            title: "CareerConnect AI",
            name: "CareerConnect AI",
            desc: "Enterprise Hiring Platform For Mid & Senior-Level Recruitment",
            logo: CCAi,
            view: CCAiView
        },
        {
            id: 'ccai-ats',
            title: "CareerConnect ATS",
            name: "CareerConnect ATS",
            desc: "Recruitment Management System For HR Agencies",
            logo: CCAts,
            view: CCAtsView
        },
        {
            id: 'hrms',
            title: "SAN HRMS",
            name: "SAN HRMS",
            desc: "Unified Workforce Management Platform",
            logo: san,
            view: HRMSView
        },
        {
            id: 'lms',
            title: "SAN LMS",
            name: "SAN LMS",
            desc: "Learning And Training Management Platform",
            logo: san,
            view: LMSView
        },
    ];
    return (
        <section className="bg-[#e9f1f7] overflow-hidden px-6">
            <div className="relative">

                {/* Pattern */}
                <img
                    src={pattren}
                    className="absolute w-full h-full object-cover"
                    alt="Pattern"
                />

                <h1 className="text-3xl md:text-5xl text-black font-bold py-10 mx-auto max-w-7xl px-4 md:px-6">
                    Our <span className="text-secondary-500">Product</span> Portfolio
                </h1>

                <div className="flex justify-center gap-12 items-center flex-wrap mx-auto max-w-7xl">

                    {products.map((item, index) => (
                        <motion.div
                            key={index}
                            // ref={ref}
                            className="flex justify-center relative z-10 cursor-pointer"
                            whileInView={{ opacity: 1, y: 0 }}
                            initial={{ opacity: 0, y: 20 }}
                            // animate={isInView ? { opacity: 1, y: 0 } : {}}
                            transition={{ duration: 0.6 }}
                            onClick={() => {
                                navigate(`/product/${item.id}`)

                            }}

                        >
                            <div className="relative group">

                                {/* NORMAL CARD */}
                                <img
                                    src={product}
                                    alt="card"
                                    className={`pointer-events-none block transition-opacity duration-500
          lg:group-hover:opacity-0
          ${isInView ? "opacity-0 lg:opacity-100" : ""}`}
                                    onContextMenu={(e) => e.preventDefault()}
                                    draggable={false}
                                />

                                {/* HOVER CARD */}
                                <img
                                    src={hoverCrad}
                                    alt="hover card"
                                    className={`absolute inset-0 transition-opacity duration-500
          lg:opacity-0 lg:group-hover:opacity-100
          ${isInView ? "opacity-100 lg:opacity-0" : "opacity-0"}`}
                                    onContextMenu={(e) => e.preventDefault()}
                                    draggable={false}
                                />

                                {/* TITLE */}
                                <p
                                    className={`absolute lg:left-12 lg:top-3 -top-3 text-xl lg:text-2xl font-medium text-black
          translate-y-4 transition-all duration-500
          lg:opacity-0 lg:group-hover:opacity-100 lg:group-hover:translate-y-0
          ${isInView ? "opacity-100 translate-y-0 lg:opacity-0" : "opacity-0"}`}
                                >
                                    {item.title}
                                </p>

                                {/* LOGO */}
                                <div className="absolute top-5 right-4">
                                    <img
                                        src={item.logo}
                                        alt={item.title}
                                        className={` sm:w-16 sm:h-20 ${item.title === 'CareerConnect ATS' ? ' w-20 h-14 sm:w-28 lg:w-28' : (item.title === 'CareerConnect AI' ? 'w-16 h-14 lg:w-[92px]' : ' w-12 lg:w-[60px]')} lg:h-20`}
                                        onContextMenu={(e) => e.preventDefault()}
                                        draggable={false}
                                    />
                                </div>

                                {/* TABLET */}
                                <div className="absolute top-20 left-14 lg:top-28 lg:left-10">
                                    <img
                                        onContextMenu={(e) => e.preventDefault()}
                                        draggable={false}
                                        src={item.view}
                                        alt="view"
                                        className={`transition-transform duration-500 lg:group-hover:scale-105 -ml-4    ${item.title === 'SAN HRMS' ? ' -mt-12 sm:-mt-8 sm:ml-9 lg:-mt-20 lg:ml-8 w-[220px] sm:w-[390px] lg:w-[415px]' : item.title === 'SAN LMS' ? ' w-[280px] sm:w-[430px] sm:-ml-0 sm:-mt-2 -ml-8 lg:ml-3 -mt-12 lg:-mt-16 lg:w-[480px]' : item.title === 'CareerConnect ATS' ? '-ml-9 w-[290px] sm:w-[430px]  -mt-9 md:-ml-0 lg:w-[460px]' : item.title === 'CareerConnect AI' && ' -mt-3 lg:ml-4 w-[230px] sm:w-[400px] sm:mt-6 sm:ml-4  lg:w-[400px]'}`}
                                    />
                                </div>

                                {/* ARROW */}
                                <div className={`w-8 h-8 sm:w-[37px] sm:h-[37px] lg:w-10 lg:h-10 bg-white rounded-full absolute lg:bottom-[105px] ${item.title === 'CareerConnect ATS' ? ' bottom-[110px] sm:bottom-[110px] responseDevice' : item.title === 'CareerConnect AI' ? ' bottom-[110px]  ' : item.title === 'SAN HRMS' ? ' bottom-[90px] sm:bottom-[110px]' : ' bottom-[110px] sm:bottom-[110px] responseDevice'} right-2 sm:right-8 lg:right-6 flex justify-center items-center shadow-md`}>
                                    <FiArrowRight className="text-base md:text-lg lg:text-xl rotate-[135deg] lg:group-hover:rotate-[315deg] transition-transform duration-500 lg:group-hover:text-secondary-500"
                                       />
                                </div>

                                {/* TEXT */}
                                <div className="px-4 py-3">
                                    <h5 className="text-black font-medium text-lg md:text-xl py-3">
                                        {item.name}
                                    </h5>

                                    <p className="text-gray-700 font-secondary text-sm md:text-base">
                                        {item.desc}
                                    </p>
                                </div>

                            </div>
                        </motion.div>
                    ))}

                </div>

            </div>
        </section>
    );
}



